module.exports = __webpack_public_path__ + "static/washi_bk-b05ad00afd38da8fd9282400d7bf33d1.jpg";